// extracted by mini-css-extract-plugin
export var currencyInput = "_km-1";
export var currencySymbol = "_km-0";